// Guardian AI Auth Service Protocol Definitions
// Single source of truth for authentication and authorization
//
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/auth/auth.proto (package guardianai.v1.auth, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/auth/auth.proto.
 */
export const file_guardianai_v1_auth_auth: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.auth.RegisterRequest
 */
export type RegisterRequest = Message<"guardianai.v1.auth.RegisterRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName: string;
};

/**
 * @generated from message guardianai.v1.auth.RegisterRequest
 */
export type RegisterRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: string password = 2;
   */
  password?: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName?: string;
};

/**
 * Describes the message guardianai.v1.auth.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest, {jsonType: RegisterRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 0);

/**
 * @generated from message guardianai.v1.auth.RegisterResponse
 */
export type RegisterResponse = Message<"guardianai.v1.auth.RegisterResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: bool requires_email_verification = 4;
   */
  requiresEmailVerification: boolean;
};

/**
 * @generated from message guardianai.v1.auth.RegisterResponse
 */
export type RegisterResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;

  /**
   * @generated from field: bool requires_email_verification = 4;
   */
  requiresEmailVerification?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse, {jsonType: RegisterResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 1);

/**
 * @generated from message guardianai.v1.auth.LoginRequest
 */
export type LoginRequest = Message<"guardianai.v1.auth.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: guardianai.v1.auth.DeviceInfo device_info = 3;
   */
  deviceInfo?: DeviceInfo;
};

/**
 * @generated from message guardianai.v1.auth.LoginRequest
 */
export type LoginRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: string password = 2;
   */
  password?: string;

  /**
   * @generated from field: guardianai.v1.auth.DeviceInfo device_info = 3;
   */
  deviceInfo?: DeviceInfoJson;
};

/**
 * Describes the message guardianai.v1.auth.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest, {jsonType: LoginRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 2);

/**
 * @generated from message guardianai.v1.auth.DeviceInfo
 */
export type DeviceInfo = Message<"guardianai.v1.auth.DeviceInfo"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: string ip_address = 3;
   */
  ipAddress: string;

  /**
   * @generated from field: string user_agent = 4;
   */
  userAgent: string;
};

/**
 * @generated from message guardianai.v1.auth.DeviceInfo
 */
export type DeviceInfoJson = {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId?: string;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName?: string;

  /**
   * @generated from field: string ip_address = 3;
   */
  ipAddress?: string;

  /**
   * @generated from field: string user_agent = 4;
   */
  userAgent?: string;
};

/**
 * Describes the message guardianai.v1.auth.DeviceInfo.
 * Use `create(DeviceInfoSchema)` to create a new message.
 */
export const DeviceInfoSchema: GenMessage<DeviceInfo, {jsonType: DeviceInfoJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 3);

/**
 * @generated from message guardianai.v1.auth.LoginResponse
 */
export type LoginResponse = Message<"guardianai.v1.auth.LoginResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 3;
   */
  refreshToken: string;

  /**
   * @generated from field: bool requires_mfa = 4;
   */
  requiresMfa: boolean;

  /**
   * @generated from field: string mfa_token = 5;
   */
  mfaToken: string;

  /**
   * @generated from field: guardianai.v1.auth.UserProfile user = 6;
   */
  user?: UserProfile;

  /**
   * @generated from field: string message = 7;
   */
  message: string;

  /**
   * True for new OAuth users who need to select a role
   *
   * @generated from field: bool needs_role_selection = 8;
   */
  needsRoleSelection: boolean;
};

/**
 * @generated from message guardianai.v1.auth.LoginResponse
 */
export type LoginResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken?: string;

  /**
   * @generated from field: string refresh_token = 3;
   */
  refreshToken?: string;

  /**
   * @generated from field: bool requires_mfa = 4;
   */
  requiresMfa?: boolean;

  /**
   * @generated from field: string mfa_token = 5;
   */
  mfaToken?: string;

  /**
   * @generated from field: guardianai.v1.auth.UserProfile user = 6;
   */
  user?: UserProfileJson;

  /**
   * @generated from field: string message = 7;
   */
  message?: string;

  /**
   * True for new OAuth users who need to select a role
   *
   * @generated from field: bool needs_role_selection = 8;
   */
  needsRoleSelection?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse, {jsonType: LoginResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 4);

/**
 * @generated from message guardianai.v1.auth.TwoFactorLoginRequest
 */
export type TwoFactorLoginRequest = Message<"guardianai.v1.auth.TwoFactorLoginRequest"> & {
  /**
   * @generated from field: string mfa_token = 1;
   */
  mfaToken: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * @generated from message guardianai.v1.auth.TwoFactorLoginRequest
 */
export type TwoFactorLoginRequestJson = {
  /**
   * @generated from field: string mfa_token = 1;
   */
  mfaToken?: string;

  /**
   * @generated from field: string code = 2;
   */
  code?: string;
};

/**
 * Describes the message guardianai.v1.auth.TwoFactorLoginRequest.
 * Use `create(TwoFactorLoginRequestSchema)` to create a new message.
 */
export const TwoFactorLoginRequestSchema: GenMessage<TwoFactorLoginRequest, {jsonType: TwoFactorLoginRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 5);

/**
 * @generated from message guardianai.v1.auth.BackupCodeLoginRequest
 */
export type BackupCodeLoginRequest = Message<"guardianai.v1.auth.BackupCodeLoginRequest"> & {
  /**
   * @generated from field: string mfa_token = 1;
   */
  mfaToken: string;

  /**
   * @generated from field: string backup_code = 2;
   */
  backupCode: string;
};

/**
 * @generated from message guardianai.v1.auth.BackupCodeLoginRequest
 */
export type BackupCodeLoginRequestJson = {
  /**
   * @generated from field: string mfa_token = 1;
   */
  mfaToken?: string;

  /**
   * @generated from field: string backup_code = 2;
   */
  backupCode?: string;
};

/**
 * Describes the message guardianai.v1.auth.BackupCodeLoginRequest.
 * Use `create(BackupCodeLoginRequestSchema)` to create a new message.
 */
export const BackupCodeLoginRequestSchema: GenMessage<BackupCodeLoginRequest, {jsonType: BackupCodeLoginRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 6);

/**
 * @generated from message guardianai.v1.auth.InitiateOAuthRequest
 */
export type InitiateOAuthRequest = Message<"guardianai.v1.auth.InitiateOAuthRequest"> & {
  /**
   * "google", "github", "facebook", "twitter"
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string redirect_uri = 2;
   */
  redirectUri: string;
};

/**
 * @generated from message guardianai.v1.auth.InitiateOAuthRequest
 */
export type InitiateOAuthRequestJson = {
  /**
   * "google", "github", "facebook", "twitter"
   *
   * @generated from field: string provider = 1;
   */
  provider?: string;

  /**
   * @generated from field: string redirect_uri = 2;
   */
  redirectUri?: string;
};

/**
 * Describes the message guardianai.v1.auth.InitiateOAuthRequest.
 * Use `create(InitiateOAuthRequestSchema)` to create a new message.
 */
export const InitiateOAuthRequestSchema: GenMessage<InitiateOAuthRequest, {jsonType: InitiateOAuthRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 7);

/**
 * @generated from message guardianai.v1.auth.InitiateOAuthResponse
 */
export type InitiateOAuthResponse = Message<"guardianai.v1.auth.InitiateOAuthResponse"> & {
  /**
   * @generated from field: string authorization_url = 1;
   */
  authorizationUrl: string;

  /**
   * CSRF protection token
   *
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * @generated from message guardianai.v1.auth.InitiateOAuthResponse
 */
export type InitiateOAuthResponseJson = {
  /**
   * @generated from field: string authorization_url = 1;
   */
  authorizationUrl?: string;

  /**
   * CSRF protection token
   *
   * @generated from field: string state = 2;
   */
  state?: string;
};

/**
 * Describes the message guardianai.v1.auth.InitiateOAuthResponse.
 * Use `create(InitiateOAuthResponseSchema)` to create a new message.
 */
export const InitiateOAuthResponseSchema: GenMessage<InitiateOAuthResponse, {jsonType: InitiateOAuthResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 8);

/**
 * @generated from message guardianai.v1.auth.OAuthCallbackRequest
 */
export type OAuthCallbackRequest = Message<"guardianai.v1.auth.OAuthCallbackRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string state = 3;
   */
  state: string;
};

/**
 * @generated from message guardianai.v1.auth.OAuthCallbackRequest
 */
export type OAuthCallbackRequestJson = {
  /**
   * @generated from field: string provider = 1;
   */
  provider?: string;

  /**
   * @generated from field: string code = 2;
   */
  code?: string;

  /**
   * @generated from field: string state = 3;
   */
  state?: string;
};

/**
 * Describes the message guardianai.v1.auth.OAuthCallbackRequest.
 * Use `create(OAuthCallbackRequestSchema)` to create a new message.
 */
export const OAuthCallbackRequestSchema: GenMessage<OAuthCallbackRequest, {jsonType: OAuthCallbackRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 9);

/**
 * @generated from message guardianai.v1.auth.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"guardianai.v1.auth.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * @generated from message guardianai.v1.auth.RefreshTokenRequest
 */
export type RefreshTokenRequestJson = {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken?: string;
};

/**
 * Describes the message guardianai.v1.auth.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest, {jsonType: RefreshTokenRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 10);

/**
 * @generated from message guardianai.v1.auth.TokenPair
 */
export type TokenPair = Message<"guardianai.v1.auth.TokenPair"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: int64 access_token_expires_at = 3;
   */
  accessTokenExpiresAt: bigint;

  /**
   * @generated from field: int64 refresh_token_expires_at = 4;
   */
  refreshTokenExpiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.auth.TokenPair
 */
export type TokenPairJson = {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken?: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken?: string;

  /**
   * @generated from field: int64 access_token_expires_at = 3;
   */
  accessTokenExpiresAt?: string;

  /**
   * @generated from field: int64 refresh_token_expires_at = 4;
   */
  refreshTokenExpiresAt?: string;
};

/**
 * Describes the message guardianai.v1.auth.TokenPair.
 * Use `create(TokenPairSchema)` to create a new message.
 */
export const TokenPairSchema: GenMessage<TokenPair, {jsonType: TokenPairJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 11);

/**
 * @generated from message guardianai.v1.auth.ValidateTokenRequest
 */
export type ValidateTokenRequest = Message<"guardianai.v1.auth.ValidateTokenRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.auth.ValidateTokenRequest
 */
export type ValidateTokenRequestJson = {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.auth.ValidateTokenRequest.
 * Use `create(ValidateTokenRequestSchema)` to create a new message.
 */
export const ValidateTokenRequestSchema: GenMessage<ValidateTokenRequest, {jsonType: ValidateTokenRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 12);

/**
 * @generated from message guardianai.v1.auth.Claims
 */
export type Claims = Message<"guardianai.v1.auth.Claims"> & {
  /**
   * @generated from field: string sub = 1;
   */
  sub: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string tenant_id = 4;
   */
  tenantId: string;

  /**
   * @generated from field: int64 exp = 5;
   */
  exp: bigint;

  /**
   * @generated from field: int64 iat = 6;
   */
  iat: bigint;

  /**
   * @generated from field: string jti = 7;
   */
  jti: string;

  /**
   * @generated from field: string token_type = 8;
   */
  tokenType: string;
};

/**
 * @generated from message guardianai.v1.auth.Claims
 */
export type ClaimsJson = {
  /**
   * @generated from field: string sub = 1;
   */
  sub?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string role = 3;
   */
  role?: string;

  /**
   * @generated from field: string tenant_id = 4;
   */
  tenantId?: string;

  /**
   * @generated from field: int64 exp = 5;
   */
  exp?: string;

  /**
   * @generated from field: int64 iat = 6;
   */
  iat?: string;

  /**
   * @generated from field: string jti = 7;
   */
  jti?: string;

  /**
   * @generated from field: string token_type = 8;
   */
  tokenType?: string;
};

/**
 * Describes the message guardianai.v1.auth.Claims.
 * Use `create(ClaimsSchema)` to create a new message.
 */
export const ClaimsSchema: GenMessage<Claims, {jsonType: ClaimsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 13);

/**
 * @generated from message guardianai.v1.auth.LogoutRequest
 */
export type LogoutRequest = Message<"guardianai.v1.auth.LogoutRequest"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.auth.LogoutRequest
 */
export type LogoutRequestJson = {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.auth.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest, {jsonType: LogoutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 14);

/**
 * @generated from message guardianai.v1.auth.LogoutResponse
 */
export type LogoutResponse = Message<"guardianai.v1.auth.LogoutResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.LogoutResponse
 */
export type LogoutResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse, {jsonType: LogoutResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 15);

/**
 * @generated from message guardianai.v1.auth.RevokeAllSessionsRequest
 */
export type RevokeAllSessionsRequest = Message<"guardianai.v1.auth.RevokeAllSessionsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.auth.RevokeAllSessionsRequest
 */
export type RevokeAllSessionsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.auth.RevokeAllSessionsRequest.
 * Use `create(RevokeAllSessionsRequestSchema)` to create a new message.
 */
export const RevokeAllSessionsRequestSchema: GenMessage<RevokeAllSessionsRequest, {jsonType: RevokeAllSessionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 16);

/**
 * @generated from message guardianai.v1.auth.RevokeAllSessionsResponse
 */
export type RevokeAllSessionsResponse = Message<"guardianai.v1.auth.RevokeAllSessionsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 sessions_revoked = 2;
   */
  sessionsRevoked: number;
};

/**
 * @generated from message guardianai.v1.auth.RevokeAllSessionsResponse
 */
export type RevokeAllSessionsResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int32 sessions_revoked = 2;
   */
  sessionsRevoked?: number;
};

/**
 * Describes the message guardianai.v1.auth.RevokeAllSessionsResponse.
 * Use `create(RevokeAllSessionsResponseSchema)` to create a new message.
 */
export const RevokeAllSessionsResponseSchema: GenMessage<RevokeAllSessionsResponse, {jsonType: RevokeAllSessionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 17);

/**
 * @generated from message guardianai.v1.auth.SetupMfaRequest
 */
export type SetupMfaRequest = Message<"guardianai.v1.auth.SetupMfaRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.auth.SetupMfaRequest
 */
export type SetupMfaRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.auth.SetupMfaRequest.
 * Use `create(SetupMfaRequestSchema)` to create a new message.
 */
export const SetupMfaRequestSchema: GenMessage<SetupMfaRequest, {jsonType: SetupMfaRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 18);

/**
 * @generated from message guardianai.v1.auth.SetupMfaResponse
 */
export type SetupMfaResponse = Message<"guardianai.v1.auth.SetupMfaResponse"> & {
  /**
   * @generated from field: string secret = 1;
   */
  secret: string;

  /**
   * @generated from field: string qr_code_url = 2;
   */
  qrCodeUrl: string;
};

/**
 * @generated from message guardianai.v1.auth.SetupMfaResponse
 */
export type SetupMfaResponseJson = {
  /**
   * @generated from field: string secret = 1;
   */
  secret?: string;

  /**
   * @generated from field: string qr_code_url = 2;
   */
  qrCodeUrl?: string;
};

/**
 * Describes the message guardianai.v1.auth.SetupMfaResponse.
 * Use `create(SetupMfaResponseSchema)` to create a new message.
 */
export const SetupMfaResponseSchema: GenMessage<SetupMfaResponse, {jsonType: SetupMfaResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 19);

/**
 * @generated from message guardianai.v1.auth.VerifyMfaSetupRequest
 */
export type VerifyMfaSetupRequest = Message<"guardianai.v1.auth.VerifyMfaSetupRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * @generated from message guardianai.v1.auth.VerifyMfaSetupRequest
 */
export type VerifyMfaSetupRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string code = 2;
   */
  code?: string;
};

/**
 * Describes the message guardianai.v1.auth.VerifyMfaSetupRequest.
 * Use `create(VerifyMfaSetupRequestSchema)` to create a new message.
 */
export const VerifyMfaSetupRequestSchema: GenMessage<VerifyMfaSetupRequest, {jsonType: VerifyMfaSetupRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 20);

/**
 * @generated from message guardianai.v1.auth.VerifyMfaSetupResponse
 */
export type VerifyMfaSetupResponse = Message<"guardianai.v1.auth.VerifyMfaSetupResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: repeated string backup_codes = 2;
   */
  backupCodes: string[];
};

/**
 * @generated from message guardianai.v1.auth.VerifyMfaSetupResponse
 */
export type VerifyMfaSetupResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: repeated string backup_codes = 2;
   */
  backupCodes?: string[];
};

/**
 * Describes the message guardianai.v1.auth.VerifyMfaSetupResponse.
 * Use `create(VerifyMfaSetupResponseSchema)` to create a new message.
 */
export const VerifyMfaSetupResponseSchema: GenMessage<VerifyMfaSetupResponse, {jsonType: VerifyMfaSetupResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 21);

/**
 * @generated from message guardianai.v1.auth.GenerateBackupCodesRequest
 */
export type GenerateBackupCodesRequest = Message<"guardianai.v1.auth.GenerateBackupCodesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.auth.GenerateBackupCodesRequest
 */
export type GenerateBackupCodesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.auth.GenerateBackupCodesRequest.
 * Use `create(GenerateBackupCodesRequestSchema)` to create a new message.
 */
export const GenerateBackupCodesRequestSchema: GenMessage<GenerateBackupCodesRequest, {jsonType: GenerateBackupCodesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 22);

/**
 * @generated from message guardianai.v1.auth.GenerateBackupCodesResponse
 */
export type GenerateBackupCodesResponse = Message<"guardianai.v1.auth.GenerateBackupCodesResponse"> & {
  /**
   * @generated from field: repeated string backup_codes = 1;
   */
  backupCodes: string[];
};

/**
 * @generated from message guardianai.v1.auth.GenerateBackupCodesResponse
 */
export type GenerateBackupCodesResponseJson = {
  /**
   * @generated from field: repeated string backup_codes = 1;
   */
  backupCodes?: string[];
};

/**
 * Describes the message guardianai.v1.auth.GenerateBackupCodesResponse.
 * Use `create(GenerateBackupCodesResponseSchema)` to create a new message.
 */
export const GenerateBackupCodesResponseSchema: GenMessage<GenerateBackupCodesResponse, {jsonType: GenerateBackupCodesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 23);

/**
 * @generated from message guardianai.v1.auth.VerifyEmailRequest
 */
export type VerifyEmailRequest = Message<"guardianai.v1.auth.VerifyEmailRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * @generated from message guardianai.v1.auth.VerifyEmailRequest
 */
export type VerifyEmailRequestJson = {
  /**
   * @generated from field: string token = 1;
   */
  token?: string;
};

/**
 * Describes the message guardianai.v1.auth.VerifyEmailRequest.
 * Use `create(VerifyEmailRequestSchema)` to create a new message.
 */
export const VerifyEmailRequestSchema: GenMessage<VerifyEmailRequest, {jsonType: VerifyEmailRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 24);

/**
 * @generated from message guardianai.v1.auth.VerifyEmailResponse
 */
export type VerifyEmailResponse = Message<"guardianai.v1.auth.VerifyEmailResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.VerifyEmailResponse
 */
export type VerifyEmailResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.VerifyEmailResponse.
 * Use `create(VerifyEmailResponseSchema)` to create a new message.
 */
export const VerifyEmailResponseSchema: GenMessage<VerifyEmailResponse, {jsonType: VerifyEmailResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 25);

/**
 * @generated from message guardianai.v1.auth.ResendVerificationRequest
 */
export type ResendVerificationRequest = Message<"guardianai.v1.auth.ResendVerificationRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.auth.ResendVerificationRequest
 */
export type ResendVerificationRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.auth.ResendVerificationRequest.
 * Use `create(ResendVerificationRequestSchema)` to create a new message.
 */
export const ResendVerificationRequestSchema: GenMessage<ResendVerificationRequest, {jsonType: ResendVerificationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 26);

/**
 * @generated from message guardianai.v1.auth.ResendVerificationResponse
 */
export type ResendVerificationResponse = Message<"guardianai.v1.auth.ResendVerificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.ResendVerificationResponse
 */
export type ResendVerificationResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.ResendVerificationResponse.
 * Use `create(ResendVerificationResponseSchema)` to create a new message.
 */
export const ResendVerificationResponseSchema: GenMessage<ResendVerificationResponse, {jsonType: ResendVerificationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 27);

/**
 * @generated from message guardianai.v1.auth.PasswordResetRequest
 */
export type PasswordResetRequest = Message<"guardianai.v1.auth.PasswordResetRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.auth.PasswordResetRequest
 */
export type PasswordResetRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.auth.PasswordResetRequest.
 * Use `create(PasswordResetRequestSchema)` to create a new message.
 */
export const PasswordResetRequestSchema: GenMessage<PasswordResetRequest, {jsonType: PasswordResetRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 28);

/**
 * @generated from message guardianai.v1.auth.PasswordResetResponse
 */
export type PasswordResetResponse = Message<"guardianai.v1.auth.PasswordResetResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.PasswordResetResponse
 */
export type PasswordResetResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.PasswordResetResponse.
 * Use `create(PasswordResetResponseSchema)` to create a new message.
 */
export const PasswordResetResponseSchema: GenMessage<PasswordResetResponse, {jsonType: PasswordResetResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 29);

/**
 * @generated from message guardianai.v1.auth.ConfirmPasswordResetRequest
 */
export type ConfirmPasswordResetRequest = Message<"guardianai.v1.auth.ConfirmPasswordResetRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * @generated from message guardianai.v1.auth.ConfirmPasswordResetRequest
 */
export type ConfirmPasswordResetRequestJson = {
  /**
   * @generated from field: string token = 1;
   */
  token?: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword?: string;
};

/**
 * Describes the message guardianai.v1.auth.ConfirmPasswordResetRequest.
 * Use `create(ConfirmPasswordResetRequestSchema)` to create a new message.
 */
export const ConfirmPasswordResetRequestSchema: GenMessage<ConfirmPasswordResetRequest, {jsonType: ConfirmPasswordResetRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 30);

/**
 * @generated from message guardianai.v1.auth.ConfirmPasswordResetResponse
 */
export type ConfirmPasswordResetResponse = Message<"guardianai.v1.auth.ConfirmPasswordResetResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.ConfirmPasswordResetResponse
 */
export type ConfirmPasswordResetResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.ConfirmPasswordResetResponse.
 * Use `create(ConfirmPasswordResetResponseSchema)` to create a new message.
 */
export const ConfirmPasswordResetResponseSchema: GenMessage<ConfirmPasswordResetResponse, {jsonType: ConfirmPasswordResetResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 31);

/**
 * @generated from message guardianai.v1.auth.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"guardianai.v1.auth.ChangePasswordRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string current_password = 2;
   */
  currentPassword: string;

  /**
   * @generated from field: string new_password = 3;
   */
  newPassword: string;
};

/**
 * @generated from message guardianai.v1.auth.ChangePasswordRequest
 */
export type ChangePasswordRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string current_password = 2;
   */
  currentPassword?: string;

  /**
   * @generated from field: string new_password = 3;
   */
  newPassword?: string;
};

/**
 * Describes the message guardianai.v1.auth.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest, {jsonType: ChangePasswordRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 32);

/**
 * @generated from message guardianai.v1.auth.ChangePasswordResponse
 */
export type ChangePasswordResponse = Message<"guardianai.v1.auth.ChangePasswordResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.auth.ChangePasswordResponse
 */
export type ChangePasswordResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema: GenMessage<ChangePasswordResponse, {jsonType: ChangePasswordResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 33);

/**
 * @generated from message guardianai.v1.auth.GetProfileRequest
 */
export type GetProfileRequest = Message<"guardianai.v1.auth.GetProfileRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.auth.GetProfileRequest
 */
export type GetProfileRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.auth.GetProfileRequest.
 * Use `create(GetProfileRequestSchema)` to create a new message.
 */
export const GetProfileRequestSchema: GenMessage<GetProfileRequest, {jsonType: GetProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 34);

/**
 * @generated from message guardianai.v1.auth.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<"guardianai.v1.auth.UpdateProfileRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;
};

/**
 * @generated from message guardianai.v1.auth.UpdateProfileRequest
 */
export type UpdateProfileRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName?: string;
};

/**
 * Describes the message guardianai.v1.auth.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest, {jsonType: UpdateProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 35);

/**
 * @generated from message guardianai.v1.auth.UserProfile
 */
export type UserProfile = Message<"guardianai.v1.auth.UserProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: bool mfa_enabled = 5;
   */
  mfaEnabled: boolean;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.auth.UserProfile
 */
export type UserProfileJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName?: string;

  /**
   * @generated from field: string role = 4;
   */
  role?: string;

  /**
   * @generated from field: bool mfa_enabled = 5;
   */
  mfaEnabled?: boolean;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.auth.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile, {jsonType: UserProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 36);

/**
 * @generated from message guardianai.v1.auth.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequest = Message<"guardianai.v1.auth.UpdateUserRoleRequest"> & {
  /**
   * New role: "User", "Analyst", "Auditor", "EvidenceScout", "Investigator", "CertificationAuthority", "Viewer"
   *
   * @generated from field: string role = 1;
   */
  role: string;
};

/**
 * @generated from message guardianai.v1.auth.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequestJson = {
  /**
   * New role: "User", "Analyst", "Auditor", "EvidenceScout", "Investigator", "CertificationAuthority", "Viewer"
   *
   * @generated from field: string role = 1;
   */
  role?: string;
};

/**
 * Describes the message guardianai.v1.auth.UpdateUserRoleRequest.
 * Use `create(UpdateUserRoleRequestSchema)` to create a new message.
 */
export const UpdateUserRoleRequestSchema: GenMessage<UpdateUserRoleRequest, {jsonType: UpdateUserRoleRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 37);

/**
 * @generated from message guardianai.v1.auth.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponse = Message<"guardianai.v1.auth.UpdateUserRoleResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.auth.UserProfile user = 3;
   */
  user?: UserProfile;
};

/**
 * @generated from message guardianai.v1.auth.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.auth.UserProfile user = 3;
   */
  user?: UserProfileJson;
};

/**
 * Describes the message guardianai.v1.auth.UpdateUserRoleResponse.
 * Use `create(UpdateUserRoleResponseSchema)` to create a new message.
 */
export const UpdateUserRoleResponseSchema: GenMessage<UpdateUserRoleResponse, {jsonType: UpdateUserRoleResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 38);

/**
 * @generated from message guardianai.v1.auth.CheckEmailExistsRequest
 */
export type CheckEmailExistsRequest = Message<"guardianai.v1.auth.CheckEmailExistsRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.auth.CheckEmailExistsRequest
 */
export type CheckEmailExistsRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.auth.CheckEmailExistsRequest.
 * Use `create(CheckEmailExistsRequestSchema)` to create a new message.
 */
export const CheckEmailExistsRequestSchema: GenMessage<CheckEmailExistsRequest, {jsonType: CheckEmailExistsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 39);

/**
 * @generated from message guardianai.v1.auth.CheckEmailExistsResponse
 */
export type CheckEmailExistsResponse = Message<"guardianai.v1.auth.CheckEmailExistsResponse"> & {
  /**
   * @generated from field: bool exists = 1;
   */
  exists: boolean;
};

/**
 * @generated from message guardianai.v1.auth.CheckEmailExistsResponse
 */
export type CheckEmailExistsResponseJson = {
  /**
   * @generated from field: bool exists = 1;
   */
  exists?: boolean;
};

/**
 * Describes the message guardianai.v1.auth.CheckEmailExistsResponse.
 * Use `create(CheckEmailExistsResponseSchema)` to create a new message.
 */
export const CheckEmailExistsResponseSchema: GenMessage<CheckEmailExistsResponse, {jsonType: CheckEmailExistsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_auth_auth, 40);

/**
 * Auth Service - 22 methods for authentication and user management
 *
 * @generated from service guardianai.v1.auth.AuthService
 */
export const AuthService: GenService<{
  /**
   * Registration
   *
   * @generated from rpc guardianai.v1.auth.AuthService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * Login flows
   *
   * @generated from rpc guardianai.v1.auth.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.TwoFactorLogin
   */
  twoFactorLogin: {
    methodKind: "unary";
    input: typeof TwoFactorLoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.BackupCodeLogin
   */
  backupCodeLogin: {
    methodKind: "unary";
    input: typeof BackupCodeLoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * OAuth flows
   *
   * @generated from rpc guardianai.v1.auth.AuthService.InitiateOAuth
   */
  initiateOAuth: {
    methodKind: "unary";
    input: typeof InitiateOAuthRequestSchema;
    output: typeof InitiateOAuthResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.HandleOAuthCallback
   */
  handleOAuthCallback: {
    methodKind: "unary";
    input: typeof OAuthCallbackRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * Token management
   *
   * @generated from rpc guardianai.v1.auth.AuthService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof TokenPairSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.ValidateToken
   */
  validateToken: {
    methodKind: "unary";
    input: typeof ValidateTokenRequestSchema;
    output: typeof ClaimsSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.RevokeAllSessions
   */
  revokeAllSessions: {
    methodKind: "unary";
    input: typeof RevokeAllSessionsRequestSchema;
    output: typeof RevokeAllSessionsResponseSchema;
  },
  /**
   * MFA
   *
   * @generated from rpc guardianai.v1.auth.AuthService.SetupMfa
   */
  setupMfa: {
    methodKind: "unary";
    input: typeof SetupMfaRequestSchema;
    output: typeof SetupMfaResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.VerifyMfaSetup
   */
  verifyMfaSetup: {
    methodKind: "unary";
    input: typeof VerifyMfaSetupRequestSchema;
    output: typeof VerifyMfaSetupResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.GenerateBackupCodes
   */
  generateBackupCodes: {
    methodKind: "unary";
    input: typeof GenerateBackupCodesRequestSchema;
    output: typeof GenerateBackupCodesResponseSchema;
  },
  /**
   * Email verification
   *
   * @generated from rpc guardianai.v1.auth.AuthService.VerifyEmail
   */
  verifyEmail: {
    methodKind: "unary";
    input: typeof VerifyEmailRequestSchema;
    output: typeof VerifyEmailResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.ResendVerification
   */
  resendVerification: {
    methodKind: "unary";
    input: typeof ResendVerificationRequestSchema;
    output: typeof ResendVerificationResponseSchema;
  },
  /**
   * Password management
   *
   * @generated from rpc guardianai.v1.auth.AuthService.RequestPasswordReset
   */
  requestPasswordReset: {
    methodKind: "unary";
    input: typeof PasswordResetRequestSchema;
    output: typeof PasswordResetResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.ConfirmPasswordReset
   */
  confirmPasswordReset: {
    methodKind: "unary";
    input: typeof ConfirmPasswordResetRequestSchema;
    output: typeof ConfirmPasswordResetResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof ChangePasswordResponseSchema;
  },
  /**
   * Profile
   *
   * @generated from rpc guardianai.v1.auth.AuthService.GetProfile
   */
  getProfile: {
    methodKind: "unary";
    input: typeof GetProfileRequestSchema;
    output: typeof UserProfileSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.UpdateProfile
   */
  updateProfile: {
    methodKind: "unary";
    input: typeof UpdateProfileRequestSchema;
    output: typeof UserProfileSchema;
  },
  /**
   * @generated from rpc guardianai.v1.auth.AuthService.UpdateUserRole
   */
  updateUserRole: {
    methodKind: "unary";
    input: typeof UpdateUserRoleRequestSchema;
    output: typeof UpdateUserRoleResponseSchema;
  },
  /**
   * Utility
   *
   * @generated from rpc guardianai.v1.auth.AuthService.CheckEmailExists
   */
  checkEmailExists: {
    methodKind: "unary";
    input: typeof CheckEmailExistsRequestSchema;
    output: typeof CheckEmailExistsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_auth_auth, 0);

